import "./closestPolyfill"
import transitionEndEventName from "./transitionEndEventName"
import elementMatches from "./elementMatches"

const AUTO_CLOSE_AFTER = 4000
const notificationSelector = ".notification"
const notificationDismissSelector = ".notification-dismiss"

const closeNotification = (notification) => {
  // Remove element from the DOM when the transition ends.
  notification.addEventListener(transitionEndEventName(), (e) => {
    notification.remove()
  }, false)
  notification.classList.replace("opacity-100", "opacity-0")
}

document.addEventListener("click", (e) => {
  const notificationDismiss = elementMatches(e.target, notificationDismissSelector)

  if (notificationDismiss) {
    e.preventDefault()
    e.stopPropagation()

    const notification = notificationDismiss.closest(notificationSelector)
    closeNotification(notification)
  }
})

document.addEventListener("DOMContentLoaded", (e) => {
  setTimeout(
    () => {
      const notifications = document.querySelectorAll(notificationSelector)
      notifications.forEach(closeNotification)
    },
    AUTO_CLOSE_AFTER
  )
})
